import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrExtraSalaryEntity } from "@odata/GeneratedEntityTypes";
import { PrExtraSalaryOriginCode, PrExtraSalaryTypeCode } from "@odata/GeneratedEnums";
import { handleCurrentTemporalPropChange } from "@odata/TemporalUtils";
import { cloneDeep } from "lodash";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

interface IProps extends IFormViewProps<IPrExtraSalaryEntity, null> {
}

class ExtraSalaryFormView extends FormViewForExtend<IPrExtraSalaryEntity, IProps> {
    static contextType = AppContext;
    static defaultProps = {
        title: "ExtraSalary:FormTitle"
    };

    handleChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;

        storage.handleChange(e);
        handleCurrentTemporalPropChange(e, storage);
        storage.refreshFields(e.triggerAdditionalTasks);
    };

    onBeforeSave(): IPrExtraSalaryEntity {
        const entity = cloneDeep(this.entity);

        if (entity.Type?.OriginCode === PrExtraSalaryOriginCode.Custom) {
            entity.TypeCode = PrExtraSalaryTypeCode.Custom;
        }

        return entity;
    }
}

export default withPermissionContext(ExtraSalaryFormView);